import { Outlet, useLocation } from 'react-router-dom';

import { Space } from '@/components/base';
import Tabs from '@/components/Tab/Tabs';
import Typo from '@/components/Typography/Typo';
import { SourceScraperMap } from '@/features/Scraping/configs';
import { getSourceByScraperNameSafe } from '@/features/Scraping/configs/config-actions';
import useWorkspaceRouter from '@/hooks/domain/useWorkspaceRouter';
import { cn } from '@/lib/cn';
import useFeedbackSourceStore from '@/stores/Feedback/FeedbackSourceStore';
import useWorkspaceStore from '@/stores/WorkspaceStore';
import { isScrapingSourceType } from '@/types/feedbackConst';

import SettingHeader from '../Header';
import { INTEGRATION_STATUS } from './types';

const IntegrationSettingLayout = () => {
  const location = useLocation();
  const wr = useWorkspaceRouter();
  const sourceInfo = useFeedbackSourceStore((state) => state.sourceInfo);
  const scraperNames = useWorkspaceStore(
    (state) => state.currWorkspace?.config.scraper_names,
  );
  const configuredSources = new Set(
    scraperNames?.map(getSourceByScraperNameSafe),
  );

  const tabs = [
    {
      id: 'platform',
      text: 'Platform',
    },
    {
      id: 'scraping',
      text: 'Scraping',
    },
  ];

  const selectedTab = location.pathname.includes('scraping')
    ? 'scraping'
    : 'platform';

  const hasScrapType = sourceInfo?.some(
    (source) =>
      isScrapingSourceType(source.source) &&
      source.status !== INTEGRATION_STATUS.DISABLE &&
      (!SourceScraperMap.has(source.source) ||
        configuredSources.has(source.source)),
  );

  return (
    <div className="flex flex-1 flex-col overflow-auto h-full">
      {hasScrapType ? (
        <div className={cn('flex flex-col px-8')}>
          <div className="flex flex-col py-5 gap-4">
            <Typo weight="sb" type="label2">
              Integration
            </Typo>
          </div>
          <Space h="12px" />
          <Tabs tabs={hasScrapType ? tabs : []} selectedTabId={selectedTab}>
            <Tabs.TabHeader
              tabColor="primary"
              tabSize="s"
              onSelect={(id) => {
                if (!id) return;
                wr.push(`/settings/integration/${id}`);
              }}
            />
          </Tabs>
        </div>
      ) : (
        <SettingHeader title="Integrations" />
      )}

      <div className="flex-1 overflow-auto">
        <Outlet />
      </div>
    </div>
  );
};

export default IntegrationSettingLayout;
